import Dropzone from "dropzone";

export const ProductUpload = {
    init() {
        this.initCsvUpload();
        this.initPdfUpload();
    },

    initCsvUpload() {
        let csvUploadForm = '.modal #SupplierUploadCatalogCsvForm',
            dropzone = new Dropzone(
                csvUploadForm,
                this.getDropzoneSettings(
                    csvUploadForm,
                    'data[SupplierCatalog][csv_catalogue_file]',
                    '.csv, .xlsx, .xls'
                ),

            );
    },

    initPdfUpload() {
        let pdfUploadForm = '.modal #SupplierUploadCatalogPdfForm',
            dropzone = new Dropzone(
                pdfUploadForm,
                this.getDropzoneSettings(
                    pdfUploadForm,
                    'data[SupplierCatalog][pdf_catalogue_file]',
                    '.pdf'
                )
            );
    },

    getDropzoneSettings(formEl, paramName, accepts) {
        let previewHtml =
        `<div class="dz-details d-flex justify-content-center align-items-center">
            <img class="img-fluid" data-dz-thumbnail />
            <div class="mx-2 font-size-14">
                <span data-dz-name></span> <span data-dz-errormessage></span>
            </div>
        </div> `;

        return {
            hiddenInputContainer: formEl,
            paramName: paramName,
            autoProcessQueue: false,
            autoQueue: false,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            clickable: formEl + ' .file-browser',
            acceptedFiles: accepts,
            previewsContainer: formEl + ' .dropzone-previews',
            previewTemplate: previewHtml,
            thumbnailWidth: 70,
            thumbnailHeight: 70,
            maxFilesize: 1000,
            init: function() {
                let self = this;
                $(formEl).find('button[type="submit"]').attr('disabled', true);
                this.on('addedfile', (file) => {
                    $(formEl).find('button[type="submit"]').removeAttr('disabled');
                    // only allow one image in the dropzone
                    while (this.files.length > this.options.maxFiles) {
                        this.removeFile(this.files[0]);
                    }
                    $(formEl).find('.modal-footer button[type="button"]')
                        .removeAttr('data-bs-dismiss').attr('type', 'submit').html('Upload file');
                });
                $(formEl).on('submit', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    self.processFiles(self.files);
                    $(formEl).find('.validating').show();
                    $(formEl).find('.modal-footer .invalid-feedback').html('');
                });
            },
            success: function(file, response) {
                if (typeof response === 'string') {
                    response = JSON.parse(response);
                }
                $(formEl).find('.validating').hide();
                if (response.success) {
                    $('#SupplierForm #SupplierCatalogPreview'). html(file.name);
                    $(formEl).find('button[type="submit"]').attr('data-bs-dismiss', 'modal').attr('type', 'button').html('Save');
                    $(formEl).find('.invalid-feedback').html('');
                    SaleHoo.TrackedEvents.track('supplierUploadCatalog');
                } else {
                    let invalidHtml = '<div class="invalid-feedback font-size-12"></div>';
                    $(formEl).find('.invalid-feedback').html(response.errors.join(' '));

                    if (response.showContinueWithoutImagesBtn) {
                        $('#SupplierDataContinueWithoutImages').val(1);
                        $(formEl).find('button[type="submit"]').text('Upload without images');
                    }
                }
            }
        }
    }
};
